let VIEW_HANDLER = {
  my_reports: 'Report',
  report_list: 'ReportList',
}

export function getView(tab) {
  return VIEW_HANDLER[tab] ?? 'StockReport'
}
